<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
        <div id="top" class="content-wrapper">
        <div  class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
            <div class="col-lg-6 float-left override-padding">
              <h3 class="d-inline heading">Assessments</h3>
              <iframe id="pdf-frame" style="display: none;""></iframe>
            </div>
            <div v-if="assessment_builder_lists.length > 0 && loading == false" class="col-lg-6 float-right override-padding" style="text-align: right;">

              <button
                      v-on:click="scrollTo('Bottom')"
                      class="btn btn-white col-4 override-padding  float-right" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                      >Jump to Bottom <i class="cursor-pointer fa fa-angle-down" style="font-size: 21px; color: #333; padding-left: 5px; vertical-align: bottom;"></i></button>



            </div>
            <div style="clear: both"></div>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div
              class="col-lg-3 col-md-12 col-12 padding-lr-5"
              style="padding-left: 0; padding-right: 0;"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Title"
              @keyup.enter="filterAssessmentBuilderitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5" style="margin-top: 2px;">
                <date-picker
                  v-model="search_date"
                  placeholder="Date"
                  format="MM/DD/YYYY"
                  v-bind:clearable="false"
                  input-class="col-md-12 input-height-30 padding-lr-5"
                  >
                  <template v-slot:icon-calendar>
                    <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  </template>
                </date-picker>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5" style="padding-left: 0; padding-right: 0;">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="status_options"
                @change="filterAssessmentBuilderitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5">
               <b-form-select
                class="input-text"
                v-model="search_user"
                :options="user_options"
                @change="filterAssessmentBuilderitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-1 col-md-4 col-4 padding-lr-5">
            <button
                @click="filterAssessmentBuilderitems()"
                class="btn btn-red col-12 padding-lr-5"
                style="height: 32px;border-radius: 10px; 
                margin-top: 2px; font-weight: bold">Search</button>
            </div>
            <div class="col-lg-2 col-md-4 col-4 padding-lr-5">
            <button
                    v-on:click="createAssessmentButton(), verrors.clear()"
                    class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 32px; border-radius: 10px; font-weight: bold;"
                    >Create Assessment</button>
            </div>
          </div>
          </div> 
          </b-collapse>
        </b-navbar>
      </div>

          <div class="margin-bottom-10"></div>
                <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin: 0;">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-bind:hide-goto-end-buttons=true
                    @input="showTasklistofPaginated()"
                    ></b-pagination>
                </div>
                <div style="clear: both"></div>
          <div>
                 <div class="row tasks_heading_row">
                   <div
                     class="bold cursor-pointer col-3"
                     v-on:click="sortMethod('title')"
                     >
                     Assessment Name
                     <i v-if="sortField == 'title' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'title' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-1 override-padding"
                     >
                     # of Sections
                     
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('createdAt')"
                     >
                     Date Created
                     <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-2 override-padding"
                     v-on:click="sortMethod('updatedBy')"
                     >
                     Last Updated By
                     <i v-if="sortField == 'updatedBy' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdBy' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('updatedAt')"
                     >
                     Last Updated
                     <i v-if="sortField == 'updatedAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'updatedAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('status')"
                     >
                     Status
                     <i v-if="sortField == 'status' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'status' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-2 override-padding"
                     v-on:click="sortMethod('createdBy')"
                     >
                     Created By
                     <i v-if="sortField == 'createdBy' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdBy' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-1 override-padding text-align-right" style="padding-right: 20px;"
                     >
                     Options
                   </div>
                 </div>


                 <!-- No Assessments Text -->
                 <div v-if="assessment_builder_lists.length == 0 && loading == false" style="background-color: #FFF; min-height: 480px; padding-top: 180px;" class="col-12 text-align-center">
                  <div class="col-12 text-align-center no-assessment-text">No assessments created</div>
                  <button
                    v-on:click="isModalVisible = true, verrors.clear()"
                    class="btn btn-white col-2 override-padding" style="margin-top: 10px; height: 35px; border-radius: 10px; font-weight: bold;"
                    >Create Assessment</button>
 
                 </div>
                <div v-show="loading" class="loading_show">
                  <div class="spinner-border text-danger"></div>
                </div>
                <div class="card-text" v-if="assessment_builder_lists.length > 0">
                <div class="tasklists-row" v-for="(list, index) in assessment_builder_lists">
                  <div class="row tasklist-item" style="margin: 0;">
                    <div
                      class="col-3"
                      >
                      {{list.title}}
                    </div>
                    <div class="col-1 override-padding text-align-center">{{ list.section_count }}</div>
                    <div class="col-1 override-padding">{{FollowDate(list.createdAt)}}</div>
                    <div class="col-2 override-padding">{{ truncate(list.updated_by) }}</div>
                    <div class="col-1 override-padding">{{FollowDate(list.updatedAt)}}</div>
                    <div class="col-1 override-padding">{{ getStatus(list.status) }}</div>
                    <div class="col-2 override-padding">{{ truncate(list.created_by) }}</div>
                    <div class="col-1 override-padding">
                      <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')" >
                        <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index" >
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                        <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                          <div class="action-dd-menu" href="" v-if="((list.status=='DRAFT' || list.status=='PUBLISH'))" @click="editAssessmentMethod(list.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                          <div class="action-dd-menu" v-if="((list.status=='DRAFT' || list.status=='PUBLISH'))" href="" @click="printAssessmentMethod(list.id)"><i class="cursor-pointer fa fa-print spacer-icon"></i>Print</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='DRAFT'" @click="publishAssessmentConfirm(list.id, list.title)"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='DRAFT' || list.status=='DEACTIVATED'" @click="deleteAssessmentConfirm(list.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='PUBLISH'" @click="deactivateAssessmentConfirm(list.id, list.title)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='DEACTIVATED'" @click="activateAssessmentConfirm(list.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Activate</div>
                          <div class="action-dd-menu"  v-if="list.status=='PUBLISH'" @click="cloneAssessment(list.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Duplicate</div>
                          <div class="action-dd-menu" v-if="((list.status=='DRAFT' || list.status=='PUBLISH'))"  @click="previewAssessment(list.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div><hr></div>
                </div>
                <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin-bottom: 0;">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-bind:hide-goto-end-buttons=true
                    @input="showTasklistofPaginated()"
                    ></b-pagination>
                </div>
                <div style="clear: both;"></div>
                </div>
          <div v-if="assessment_builder_lists.length > 0 && loading == false" style="margin-top: 20px; margin-bottom: 30px;">
            <div class="col-lg-10 float-left override-padding">
              &nbsp;
            </div>
            <div class="col-lg-2 float-left override-padding">
              <button
                      v-on:click="scrollTo('Top')"
                      class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                      >Jump to Top <i class="cursor-pointer fa fa-angle-up" style="font-size: 21px; color: #333; padding-left: 5px; vertical-align: bottom;"></i></button>
            </div>
            <div style="clear: both"></div>
          </div>


         </div>
      </div>


      </div>
    </div>
    <CreateAssessmentModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Create Assessment</h3></div>
      <div slot="body">

        <div class="col-12 override-padding">
          <input v-model="assessment_title"
                name="assessment_title"
                placeholder="Enter Assessment Title..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required'"
                maxlength="255" />
         <div v-if="verrors.firstByRule('assessment_title', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment Title is required</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="affiliate_selected"
            :options="affiliate_options" track-by="name" label="name"
            placeholder="Select Affiliates..." :multiple="true"  :close-on-select="false" :show-labels="false"
            v-validate="'required'"
            name="affiliate"
            id="affiliate"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
          </multiselect>
          <div v-if="verrors.firstByRule('affiliate', 'required')" class="margin-bottom-5 validate-warning-msg">Affilates is required</div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
  
        <div class="col-12 override-padding">
          <div class="search-padd" id="mentee-group-wrapper">
          <multiselect
            v-model="roles_selected"
            :options="roles_options"
            track-by="name" label="name"
            placeholder="Select Users..."
            :multiple="true" 
            :close-on-select="false"
            :show-labels="false"
            v-validate="'required'"
            name="roles"
            id="roles"
            >
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
      

          </multiselect>
          <div v-if="verrors.firstByRule('roles', 'required')" class="margin-bottom-5 validate-warning-msg">Users is required</div>

          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="createAssessment()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Continue</b></button>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </CreateAssessmentModal>

    <PublishModal :isModalVisible="isPublishModalVisible" :id="id"  @close="isPublishModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"></div>
      <div slot="body">
        <div class="publish-header">Are you sure you want to publish the assessment</div>
        <div class="assessment-title">{{ assessmentTitle }}?</div>
        <div class="publish-content">Doing so will make the assessment active for all associated affiliates. Only publish the assessment when manager's have directed you to do so.</div>
        <div class="col-12 override-padding" style="margin-top: 20px;">
          <div class="col-6 text-align-center float-left">
            <button class="left col-8 btn btn-red" style="height: 35px;border-radius: 10px;font-weight: bold;font-size:12px;background-color: #FF0000;" @click="isPublishModalVisible = false">No! Don't Publish</button>
          </div>
          <div class="col-6 text-align-center float-left">
            <button class="left col-8 btn btn-white" style="height: 35px;border-radius: 10px;font-weight: bold;font-size:12px;" @click="publishAssessment(id)">Yes! Publish</button>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div slot="footer" class="col-3 override-padding">
      </div>
    </PublishModal>

    <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deleteAssessment(id)">Confirm</button>
      </div>
    </DeleteModal>

    <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to deactivate? </div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deactivateAssessment(deactivateId)">Confirm</button>
      </div>
    </DeactivateModal>

    <ActivateModal :isModalVisible="isActivateModalVisible" :id="activateId"  @close="isActivateModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to Activate? </div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="activateAssessment(activateId)">Confirm</button>
      </div>
    </ActivateModal>

      <CheckAssessmentValidationModal :isModalVisible="isDeactivateValidateModalVisible" @close="isDeactivateValidateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">The assessment "{{ assessmentTitle }}" has been assigned to some users, you can't deactivate this assessment</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CheckAssessmentValidationModal>





  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import CreateAssessmentModal from '../admin/create-tasklist-modal.vue';
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import PublishModal from '../shared/publish_modal_alert.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';
import CheckAssessmentValidationModal from '../shared/validation_modal_alert.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
        data() {
          return {
            filterFlag: false,
            rows: 0,
            perPage: 25,
            currentPage: 1,
            assessment_builder_lists: [],
            search_status: '',
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            task_lists: [],
            private_task_lists: [],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            loading: false,
            sortField: 'title',
            sortBy: 'ASC',
            search_date: '',
            search_user: '',
            user_options: [],
            isModalVisible: false,
            assessment_title: '',
            affiliate_options: [],
            index: 1,
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
              {
                name: 'Student',
                value: 'ROLE_STUDENT',
              },
            ],
            affiliate_selected: [],
            roles_selected: [],
            id: '',
            deactivateId: '',
            activateId: '',
            isDeleteModalVisible: false,
            isActivateModalVisible: false,
            isDeactivateModalVisible: false,
            isDeactivateValidateModalVisible: false,
            showOverlay: false,
            isPublishModalVisible: false,
            assessmentTitle: '',
            apiUrl: '',
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          CreateAssessmentModal,
          Multiselect,
          DatePicker,
          DeleteModal,
          DeactivateModal,
          PublishModal,
          ActivateModal,
          CheckAssessmentValidationModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            scrollTo: function(arg) {
              if(arg == 'Top') {
                let elmnt = document.getElementById('top');
                elmnt.scrollIntoView(true);
              }
              else {
                let elmnt = document.getElementById('top');
                elmnt.scrollIntoView(false);
              }
            },
            truncate: function (text) {
              if(text) {
                if (text.length > 10) {
                    return text.substring(0, 10) + '...';
                } else {
                    return text;
                }
              }
            },
            createAssessmentButton: function() {
              this.isModalVisible = true;
            },
            editAssessmentMethod: function(assessment_id) {
              this.$store.dispatch('assessment_sections', '');
              router.push("/assessment-add-section/" + assessment_id);
            },
            printAssessmentMethod: function(assessment_id) {
              this.apiUrl = process.env.API_ENDPOINT;
              this.showOverlay = true;
              axios.get('/assessment-print-preview-page/' + assessment_id, {

              })
              .then((resp) => {
                this.showOverlay = false;
                fetch(this.apiUrl + '/custom/pdf-view/' + resp.data).then(function(response) {
                    return response.blob();
                }).then(function(myBlob) {
                    var objectURL = URL.createObjectURL(myBlob);
                    document.querySelector('#pdf-frame').src = '';
                    document.querySelector('#pdf-frame').src = objectURL;
                    objectURL = URL.revokeObjectURL(myBlob);
                }).then(
                    function() {
                        window.setTimeout(function() {
                          document.querySelector('#pdf-frame').contentWindow.print();
                        }, 1000)
                    });
                  return false;
              })
              .catch(() => {

              });
            },
            previewAssessment: function(assessment_id) {
              axios('/user-assessment-attempts/' + assessment_id,
              {
                method: 'POST',
              })
              .then((resp) => {
                router.push('/assessment-landing-page/' + assessment_id + '/' + resp.data);
              })
              .catch(() => {

              });
            },
            cloneAssessment: function(assessment_id) {
             this.showOverlay = true;
             axios('/clone-assessment/' + assessment_id,
              {
                method: 'POST',
              }
             )
             .then((resp) => {
                this.showOverlay = false;
                this.$store.dispatch('assessment_sections', '');
                router.push("/assessment-add-section/" + resp.data);
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });

            },
            updateAssessmentStatus(assessment_id, status_text) {
              this.showOverlay = true;
              if(status_text == 'PUBLISH') {
                axios.get('/checkAssessmentOutput/' + assessment_id, {

                })
                .then((resp) => {
                  var assessmentOutputRangesFlag = resp.data;
                  if(assessmentOutputRangesFlag == 1) {
                    axios('/assessment-builder-status/' + assessment_id,
                     {
                       method: 'PATCH',
                       data: { "status": status_text},
                     }
                    )
                    .then((resp) => {
                      this.showOverlay = false;
                      this.fetchAssessmentBuilderitems();
                    })
                    .catch(error => {
                        if(error.response.data.message == 'Access denied.') {
                          router.push("/forbidden");
                        }
                    });
                  }
                  else {
                    this.showOverlay = false;
                    alert("Please add output ranges to this assessment before publishing");
                    return false;
                  }
                })
                .catch(error => {

                });
              }
              else {
                axios('/assessment-builder-status/' + assessment_id,
                 {
                   method: 'PATCH',
                   data: { "status": status_text},
                 }
                )
                .then((resp) => {
                  this.showOverlay = false;
                  this.fetchAssessmentBuilderitems();
                })
                .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                });
              }
            },
            activateAssessmentConfirm(assessment_id) {
              this.isActivateModalVisible = true;
              this.activateId = assessment_id;
            },
            activateAssessment(assessment_id) {
              this.isActivateModalVisible = false;
              this.showOverlay = true;
              this.updateAssessmentStatus(assessment_id, 'PUBLISH');
            },
            deactivateAssessmentConfirm(assessment_id, assessment_title) {
              axios('/check-assessment-assign-count/' + assessment_id,
                 {
                   method: 'GET',
                 }
               )
              .then((resp) => {
                  if (resp.data.isAssessmentValidation) {
                    this.isDeactivateModalVisible = true;
                    this.deactivateId = assessment_id;
                  } else {
                    this.isDeactivateValidateModalVisible = true;
                    this.assessmentTitle = assessment_title;
                  }
               })
              .catch(error => {

              });
            },
            publishAssessmentConfirm(assessment_id, assessment_title) {
              this.isPublishModalVisible = true;
              this.id = assessment_id;
              this.assessmentTitle = assessment_title;
            },
            deactivateAssessment(assessment_id) {
              this.isDeactivateModalVisible = false;
              this.showOverlay = true;
              this.updateAssessmentStatus(assessment_id, 'DEACTIVATED');
            },
            publishAssessment(assessment_id) {
              this.isPublishModalVisible = false;
              this.showOverlay = true;
              this.updateAssessmentStatus(assessment_id, 'PUBLISH');
            },
            deleteAssessmentConfirm: function(assessment_id) {
              this.isDeleteModalVisible = true;
              this.id = assessment_id;
            },
            deleteAssessment: function(assessment_id) {
              this.isDeleteModalVisible = false;
              this.showOverlay = true;
              axios('/assessment-builder/' + assessment_id,
                 {
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchAssessmentBuilderitems();
               })
              .catch(error => {

              });
            },
            FollowDate(value) {
              return moment(String(value)).utc().format('MM/DD/YYYY')
            },
           sortMethod: function(field) {
             this.sortField = field;
             if(this.sortBy == 'ASC') {
               this.sortBy = 'DESC';
             }
             else {
               this.sortBy = 'ASC';
             }
             this.fetchAssessmentBuilderitems();
           },
           showTasklistofPaginated() {
               this.fetchAssessmentBuilderitems();
               this.filterFlag = false;
            },
            filterAssessmentBuilderitems() {
               this.filterFlag = true;
               this.fetchAssessmentBuilderitems();
            },
           fetchUserOptions: function() {
             axios.get('/masteradmin-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: 'Created By'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });

           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, name: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },
           createAssessment: function() {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  axios('/assessment-builder',
                     {
                       method: 'POST',
                       data:
                        {
                          title: this.assessment_title,
                          affiliate_selected: this.affiliate_selected,
                          roles_selected: this.roles_selected,
                        },
                     }
                   )
                  .then((resp) => {
                      this.assessment_title = '';
                      this.affiliate_selected = [];
                      this.roles_selected = [];
                      this.isModalVisible = false;
                      this.$emit('close');
                      this.$store.dispatch('assessment_sections', '');
                      router.push("/assessment-add-section/" + resp.data);


                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

              }
            });
           },
            fetchAssessmentBuilderitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_keyword) {
                params.title = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_user) {
                params.search_user = this.search_user
              }
              if (this.search_date) {
                const dateStr = moment(this.search_date).format('YYYY-MM-DD HH:mm:ss');
                params.search_date = dateStr;
              }
              if (this.sortField) {
                params.sortfield = this.sortField
              }
              if (this.sortBy) {
                params.sortby = this.sortBy
              }
              axios.get('/assessment-builder', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.assessment_builder_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
           getStatus: function(status) {
             var status_val = this.status_options.findIndex(item => item.value === status);
             return this.status_options[status_val].text;
           },

            toggleDropdown (id) {
              document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
              var matches = document.getElementsByClassName('dropdown-content');
              for (var i=0; i<matches.length; i++) {
                var container = document.getElementById('dropdown-container'+ i);
                if (!container.contains(e.target)) {
                     if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                        document.getElementById('actionDropdown' + i).classList.remove('show');
                     }
                }
              }
            },
          },
          mounted() {
            document.addEventListener('click', this.hideActionMenu);
          },
          beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
          },
         created() {
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           this.fetchUserOptions();
           this.fetchAffiliateOptions();
           this.fetchAssessmentBuilderitems();
         }
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.no-assessment-text {
  font-size: 20px;
  color: #8b8b8b;
}
.mx-datepicker {
  width: 100%;
}
.custom-select {
  height: 35px;
}
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #fff !important;
}
.assessment-title {
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
  font-weight: bold;
  font-size: 16px;
}
.publish-content {
  padding: 10px 40px;
  text-align: center;
  font-size: 13px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/assessment_builder_list.vue